import { IS_DEV_ENVIRONMENT } from "utils/constants"

export enum TrackingEvents {
  // Payment Events
  productPurchaseStatus = "product_purchase_status",
  orderCheckout = "order_checkout",
  purchase = "purchase",

  // Suraasa Plus DirectPayment Flow Events
  suraasaPlusFlowViewed = "suraasa_plus_flow_viewed",
  suraasaPlusUserDetailsFormViewed = "suraasa_plus_user_details_form_viewed",
  suraasaPlusUserDetailsFormCompleted = "suraasa_plus_user_details_form_completed",
  suraasaPlusPackageSelectionViewed = "suraasa_plus_package_selection_viewed",
  suraasaPlusPlanSelected = "suraasa_plus_plan_selected",
  suraasaPlusCheckoutInitiated = "suraasa_plus_checkout_initiated",
  suraasaPlusOrderCreated = "suraasa_plus_order_created",
  suraasaPlusPaymentCompleted = "suraasa_plus_payment_completed",
  suraasaPlusSignUpAttempted = "suraasa_plus_sign_up_attempted",
  suraasaPlusUserlessFlowInitiated = "suraasa_plus_userless_flow_initiated",

  // Masterclasses Events
  masterclassesPageViewed = "masterclasses_page_viewed",
  masterclassesTabChanged = "masterclasses_tab_changed",
  masterclassSearched = "masterclass_searched",
  masterclassSortChanged = "masterclass_sort_changed",
  masterclassCardClicked = "masterclass_card_clicked",
  masterclassDetailViewed = "masterclass_detail_viewed",
  masterclassRegistrationAttempted = "masterclass_registration_attempted",
  masterclassRegistrationCompleted = "masterclass_registration_completed",
  masterclassVideoPlayed = "masterclass_video_played",
  masterclassCertificateDownloaded = "masterclass_certificate_downloaded",
  masterclassShareClicked = "masterclass_share_clicked",
  masterclassOnboardingStarted = "masterclass_onboarding_started",
  masterclassOnboardingCompleted = "masterclass_onboarding_completed",
  masterclassVideoStarted = "masterclass_video_started",
  masterclassVideoCompleted = "masterclass_video_completed",
  masterclassVideoProgress = "masterclass_video_progress",

  // Spny Onboarding event
  spnyOnboardingTourStatus = "SPNY_ONBOARDING_TOUR_STATUS",

  // Profile events
  profilePersonalDetailsUpdated = "profile_personal_details_updated",
  profileTourStarted = "profile_tour_started",
  profileCareerAspirationUpdated = "profile_career_aspiration_updated",
  profileAcademicCertificationAdded = "profile_academic_certification_added",
  profileAcademicQualificationAdded = "profile_academic_qualification_added",
  profileLanguageAdded = "profile_language_added",
  profileResumeUploaded = "profile_resume_uploaded",
  referenceRequestFormCompleted = "reference_request_form_completed",
  referenceRequestFormClosed = "reference_request_form_closed",
  referenceRequestReminderSent = "reference_request_reminder_sent",
  profileSubjectAdded = "profile_subject_added",
  profileWorkExperienceAdded = "profile_work_experience_added",
  profileWorkLocationInterestAdded = "profile_work_location_interest_added",
  profileTourCompleted = "profile_tour_completed",
  profileVideoPortfolioUploaded = "profile_video_portfolio_uploaded",

  // Navigation Events
  navMoreLinkClicked = "nav_more_link_clicked",

  // AI Tools Events
  aiToolOutputUpvoted = "ai_tool_output_upvoted",
  aiToolOutputDownvoted = "ai_tool_output_downvoted",
  aiToolsGenerationStarted = "ai_tools_generation_started",
  aiToolsGenerationSuccess = "ai_tools_generation_success",
  aiToolsGenerationFailed = "ai_tools_generation_failed",
  aiToolOutputCopied = "ai_tool_output_copied",
  aiToolsExportSuccess = "ai_tools_export_success",
  aiToolsExportFailed = "ai_tools_export_failed",
  aiToolStreamingStarted = "ai_tool_streaming_started",
  aiToolStreamingSuccess = "ai_tool_streaming_success",
  aiToolStreamingFailed = "ai_tool_streaming_failed",
  aiToolRegenerationStarted = "ai_tool_regeneration_started",
  aiToolRegenerationSuccess = "ai_tool_regeneration_success",
  aiToolRegenerationFailed = "ai_tool_regeneration_failed",

  // CPAT Events
  cpatSubmitAssessment = "cpat_submit_assessment",
  cpatSubmitAPICalled = "cpat_submit_assessment_api_called",
  cpatSelectQuestion = "cpat_select_question",
  cpatPreviousQuestion = "cpat_previous_question",
  cpatNextQuestion = "cpat_next_question",
  cpatNavigateQuestions = "cpat_navigate_questions",
  cpatConfirmSubmitAssessment = "cpat_confirm_submit_assessment",
  cpatProctoringViolation = "cpat_proctoring_violation",
  cpatReportDownloaded = "CPAT_REPORT_DOWNLOADED",
  cpatAttemptAssessment = "cpat_attempt_assessment",
  cpatMarkAnswer = "cpat_mark_answer",
  cpatOnboardingTourStatus = "cpat_onboarding_tour_status",

  // CPAT Proctoring Instruction Events
  cpatProcInitStepViewed = "cpat_proc_init_step_viewed",
  cpatProcInitSystemCheckProceedClicked = "cpat_proc_init_system_check_proceed_clicked",
  cpatProcInitBrowserTroubleshootClicked = "cpat_proc_init_browser_troubleshoot_clicked",
  cpatProcInitCameraTroubleshootClicked = "cpat_proc_init_camera_troubleshoot_clicked",
  cpatProcInitFaceCaptureClicked = "cpat_proc_init_face_capture_clicked",
  cpatProcInitFaceRetakenClicked = "cpat_proc_init_face_retake_clicked",
  cpatProcInitFaceSubmitClicked = "cpat_proc_init_face_submit_clicked",
  cpatProcInitFaceSubmitSuccess = "cpat_proc_init_face_submit_success",
  cpatProcInitFaceSubmitFailed = "cpat_proc_init_face_submit_failed",
  cpatProcInitGuidelinesViewed = "cpat_proc_init_guidelines_viewed",
  cpatProcInitSessionStarted = "cpat_proc_init_session_started",
  cpatProcInitCamerasList = "cpat_proc_init_cameras_list",

  // Course Assessment Events
  assessmentAttemptStarted = "assessment_attempt_started",
  assessmentMarkAnswer = "assessment_mark_answer",
  assessmentSubmit = "assessment_submit",
  assessmentConfirmSubmit = "assessment_confirm_submit",

  // Dashboard Tour Events
  dashboardTourStarted = "dashboard_tour_started",
  dashboardTourCompleted = "dashboard_tour_completed",

  // SignupOnboarding Events
  signupOnboardingQSkipped = "signup_onboarding_q_skipped",
  signupOnboardingQAnswered = "signup_onboarding_q_answered",
  signupOnboardingPresented = "signup_onboarding_presented",
  signupOnboardingCompleted = "signup_onboarding_completed",
  signupOnboardingStarted = "signup_onboarding_started",

  // ITO Events
  itoDashboardLoad = "ITO_DASHBOARD_LOAD",
  ito2023CertificateDownload = "ito_2023_certificate_download",
  ito2023CertificateShare = "ito_2023_certificate_share",

  // Learning Events
  userLearningActivity = "user_learning_activity",
  libraryItemClicked = "library_item_clicked",
  enrollmentAgreementPresented = "ENROLLMENT_AGREEMENT_PRESENTED",
  enrollmentAgreementLoadFailed = "ENROLLMENT_AGREEMENT_LOAD_FAILED",
  enrollmentAgreementDocumentLoadFailed = "ENROLLMENT_AGREEMENT_DOCUMENT_LOAD_FAILED",
  enrollmentAgreementStepViewed = "ENROLLMENT_AGREEMENT_STEP_VIEWED",
  enrollmentAgreementStepCompleted = "ENROLLMENT_AGREEMENT_STEP_COMPLETED",
  enrollmentAgreementValidationFailed = "ENROLLMENT_AGREEMENT_VALIDATION_FAILED",
  enrollmentAgreementSubmitFailed = "ENROLLMENT_AGREEMENT_SUBMIT_FAILED",
  enrollmentAgreementCompleted = "ENROLLMENT_AGREEMENT_COMPLETED",
  enrollmentAgreementDismissed = "ENROLLMENT_AGREEMENT_DISMISSED",
  orientationVideoPresented = "ORIENTATION_VIDEO_PRESENTED",
  orientationVideoStarted = "ORIENTATION_VIDEO_STARTED",
  orientationVideoProgress = "ORIENTATION_VIDEO_PROGRESS",
  orientationVideoCompleted = "ORIENTATION_VIDEO_COMPLETED",
  assignmentTutorialVideoStarted = "ASSIGNMENT_TUTORIAL_VIDEO_STARTED",
  assignmentTutorialVideoProgress = "ASSIGNMENT_TUTORIAL_VIDEO_PROGRESS",
  assignmentTutorialVideoCompleted = "ASSIGNMENT_TUTORIAL_VIDEO_COMPLETED",

  //Smart banner Events
  smartbannerViewed = "smartbanner_viewed",
  smartbannerClicked = "smartbanner_clicked",
  smartbannerClosed = "smartbanner_closed",

  cpatQuestionnairePresented = "cpat_questionnaire_presented",

  // PgCTL Self-Enroll Events
  pgctlSelfEnrollRegistrationStarted = "pgctl_self_enroll_registration_started",
  pgctlSelfEnrollRegistrationEnded = "pgctl_self_enroll_registration_ended",

  // Other Events
  elementClicked = "element_clicked",
  wtmPopupDismissed = "wtm_popup_dismissed",
}

const HS_PREFIX = IS_DEV_ENVIRONMENT ? "pe49272335" : "pe48613855"

export const HubSpotTrackingEvents = {
  productPurchaseStatus: `${HS_PREFIX}_product_purchase_status`,
  pgctlSelfEnrollRegistrationStarted: `${HS_PREFIX}_pgctl_self_enroll_registration_started`,
  pgctlSelfEnrollRegistrationEnded: `${HS_PREFIX}_pgctl_self_enroll_registration_ended`,
} as const
